import React, { Component } from "react";
import {
  Button,
  Table,
  Alert,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import Pagination from "react-js-pagination";
import * as chuongTrinhProductConstant from './constants'
import * as chuongTrinhProductAction from './actions'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';

class ChuongTrinhProduct extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    chuongTrinhNganhHangListRequest: PropTypes.func,
    chuongTrinhProductListRequest: PropTypes.func,
    chuongTrinhUpdateProductRequest: PropTypes.func,
    chuongTrinhProduct: PropTypes.shape({
      listNganhHang: PropTypes.array,
      resultProduct: PropTypes.array,
      resultProductCt: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      listNganhHang: [],
      keyword: '',
      selectedOption: null,
      NganhHangId: 0,
      formError: [],
      page: 1,
      per_page: 100,
      NameCt: this.getParam("name") || ''
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.featchProduct);
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handleNganhHangChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ NganhHangId: selectedOption.value }, () => {
      this.featchProduct();
    });
  };
  BackToListChuongTrinh = (item, e) => {
    e.preventDefault();
    this.props.history.push('/chuong-trinh');
  }
  featchProduct = () => {
    const { chuongTrinhProductListRequest } = this.props
    var requestData = {
      ChuongTrinhId: this.getParam("cid") || 0,
      keyword: this.state.keyword,
      stores_id: this.state.StoreId,
      NganhHangId: this.state.NganhHangId || 0,
      page: this.state.page,
      per_page: this.state.per_page,
    }
    return chuongTrinhProductListRequest(requestData);
  }
  fetchListNganhHang = () => {
    const { chuongTrinhNganhHangListRequest } = this.props

    var requestData = {
      StoreId: this.state.StoreId,
      keyword: this.state.keyword,
      status: 0,
      page: 1,
      per_page: 100
    };
    return chuongTrinhNganhHangListRequest(requestData);
  }
  filterListProductCt = (event) => {
    var updatedList = this.props.chuongTrinhProduct.resultProductCt;
    updatedList = updatedList.filter(function (item) {
      return (item.Ten.toLowerCase().search(event.target.value.toLowerCase()) !== -1) || (item.NganhHang.toLowerCase().search(event.target.value.toLowerCase()) !== -1)
    });
    this.setState({ listProductCt: updatedList })
  }
  UpdateChuongTrinhProduct = (res) => {
    var chuongTrinhId = this.getParam("cid") || 0;
    if (chuongTrinhId && chuongTrinhId > 0) {
      var requestData = {
        ChuongTrinhId: chuongTrinhId,
        ProductIds: (res.ProductId ? [res.ProductId] : []),
        ChuongTrinhCtIds: (res.ChuongTrinhCtId ? [res.ChuongTrinhCtId] : [])
      }
      this.props.chuongTrinhUpdateProductRequest(requestData);
    }
  }
  UpdateAll = (res, flag) => {
    var formError = this.state.formError;
    formError = [];
    var chuongTrinhId = this.getParam("cid") || 0;
    if (chuongTrinhId && chuongTrinhId > 0) {
      var requestData = {
        ChuongTrinhId: chuongTrinhId,
        ProductIds: (flag == "add" ? res.map(function(item) {return item.ProductId}) : []),
        ChuongTrinhCtIds: (flag == "remove" ? res.map(function(item) {return item.ChuongTrinhCtId}) : [])
      }
      this.props.chuongTrinhUpdateProductRequest(requestData);
    } 
  }
  processUpdateAllClick = (res, flag) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn cập nhật tất cả dữ liệu này không?
            </p>
            <button className="text-danger" onClick={() => {
              this.UpdateAll(res, flag)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  componentDidMount() {
    this.fetchListNganhHang();
    this.featchProduct();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.chuongTrinhProduct.type == chuongTrinhProductConstant.CHUONGTRINH_NGANHHANG_LIST_SUCCESS) {
      let { listNganhHang, item } = nextProps.chuongTrinhProduct;
      this.setState({
        listNganhHang: this.BuildSelectOption(listNganhHang)
      });
    } else if (nextProps.chuongTrinhProduct.type == chuongTrinhProductConstant.CHUONGTRINH_PRODUCT_LIST_SUCCESS) {
      let { item, resultProductCt } = nextProps.chuongTrinhProduct;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        listProductCt: resultProductCt
      });
    } else if (nextProps.chuongTrinhProduct.type == chuongTrinhProductConstant.CHUONGTRINH_UPDATE_PRODUCT_SUCCESS) {
      this.featchProduct();
    }
  }
  BuildSelectOption(list) {
    var options = [];
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.NganhHangId, label: item.Ten }) }
      );
    }
    return options;
  }
  render() {
    const { selectedOption, listNganhHang, listProductCt } = this.state;
    const {
      handleSubmit,
      chuongTrinhProduct: {
        listRequesting,
        resultProduct,
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <Button size="md" color="success" className="mr-1" onClick={this.BackToListChuongTrinh.bind(this, {})}><i className="fa fa-list"></i> Danh sách chương trình</Button>
          <div className="mt-2 bg-white">
            <div className="w-100 row">
              <div className="col-sm-6">
                <Alert color="primary">Danh sách sản phẩm</Alert>
                <div className="row">
                  <div className="col-sm-6">
                    <InputGroup size="md">
                      <Select className="w-100"
                        placeholder="Chọn nhóm hàng"
                        value={selectedOption}
                        onChange={this.handleNganhHangChange}
                        options={listNganhHang}
                      />
                    </InputGroup>
                  </div>
                  <div className="col-sm-6">
                    <InputGroup>
                      <Input placeholder="Nhập tên sản phẩm" onChange={this.handleSearchChange.bind(this, "keyword")} />
                      <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                        <Button color="success" onClick={handleSubmit(this.featchProduct)}>
                          <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </div>
                </div>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" className="text-left">Tên sản phẩm</th>
                      <th scope="col" width="100" className="text-left">Ngành hàng</th>
                      <th scope="col" width="10" className="text-left">
                        <ButtonExt
                          btnClass="text-primary"
                          iconClass="fa-arrow-right fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(resultProduct,"add")}
                          permission={BtnPermissions.ChuongTrinh.UPDATE_PRODUCT} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultProduct && !!resultProduct.length && (
                      resultProduct.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-left">{res.Ten}</td>
                          <td className="text-left">{res.NganhHang}</td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateChuongTrinhProduct(res)}
                              permission={BtnPermissions.ChuongTrinh.UPDATE_PRODUCT} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                {this.state.total_record > this.state.per_page && (
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                )}
              </div>
              <div className="col-sm-6">
                <Alert color="success">Danh sách sản phẩm trong chương trình: <span className="text-danger">{this.state.NameCt}</span></Alert>
                <InputGroup>
                  <Input placeholder="Nhập tên sản phẩm" onChange={this.filterListProductCt} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" >
                      <i className="fa fa-search"></i> Tìm kiếm
                      </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="10" className="text-center">
                        <ButtonExt
                          btnClass="text-danger"
                          iconClass="fa-arrow-left fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(listProductCt,"remove")}
                          permission={BtnPermissions.ChuongTrinh.ADD_OR_UPDATE} />
                      </th>
                      <th scope="col" className="text-left">Tên sản phẩm</th>
                      <th scope="col" width="100" className="text-left">Ngành hàng</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listProductCt && !!listProductCt.length && (
                      listProductCt.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdateChuongTrinhProduct(res)}
                              permission={BtnPermissions.ChuongTrinh.UPDATE_PRODUCT} />
                          </td>
                          <td className="text-left">{res.Ten}</td>
                          <td className="text-left">{res.NganhHang}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  chuongTrinhProduct: state.chuongTrinhProduct,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  chuongTrinhNganhHangListRequest: chuongTrinhProductAction.chuongTrinhNganhHangListRequest,
  chuongTrinhProductListRequest: chuongTrinhProductAction.chuongTrinhProductListRequest,
  chuongTrinhUpdateProductRequest: chuongTrinhProductAction.chuongTrinhUpdateProductRequest,
})(ChuongTrinhProduct)
const formed = reduxForm({
  form: 'chuongTrinhProduct',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/ChuongTrinhProduct.js